"use client";

import { PrismicRichText } from "@prismicio/react";
import React, { useEffect } from "react";
import GoogleReview from "@/components/GoogleReview"
import { uid } from "uid";

/**
 * @typedef {import("@prismicio/client").Content.FormSlice} FormSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<FormSlice>} FormProps
 * @param {FormProps}
 */
const Form = ({ slice, index }) => {

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/shell.js';
    document.body.appendChild(script);

    script.addEventListener('load', () => {
      if (window.hbspt) {
        console.log('loaded')
        window.hbspt.forms.create({
          region: "na1",
          portalId: "20272221",
          target: '#laformaflo',
          formId: slice.primary.form_id,
          onFormSubmit: function ($form) {
            console.log('submitting', $form);
            const inputs = $form.querySelectorAll('input[name="email"]')
            dataLayer.push({ 'event': 'form_submit__' + slice.primary.form_id, email: inputs[0].value });
            if (window.ndrstnd !== undefined) {
              window.ndrstnd(function (client) {
                const getField = function (key) {
                  const found = $form.querySelectorAll('input[name="' + key + '"]')[0];
                  return found ? found.value : null;
                };
                const getSelect = function (key) {
                  const found = $form.querySelectorAll('select[name="' + key + '"]')[0].querySelectorAll('option:checked')[0]
                  console.log('getselected found', found)
                  return found ? found.value : null
                }
                const tracker = client.getTracker().get('fc');
                fetch('https://api.webmarketer.io/api/v1/events', {
                  method: 'POST',
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    projectId: 'berkail',
                    eventType: 'project',
                    trackerId: tracker,
                    nonce: uid(), // identifiant unique de la soumission du formulaire ou identifiant unique généré
                    data: {
                      avancement: getSelect('avancement_acquisition'),
                      bien: getSelect('home_type'),                      // valeur du champ "Tout d’abord quel type de bien souhaites-tu rénover ?"
                      usage: getSelect('revamp_to_do_what'),             // valeur du champ "Pour quel usage ?"
                      superficie: parseInt(getField('m2_to_revamp')),   // valeur du champ "Quelle superficie souhaites-tu rénover (en m2) ?" (en nombre)
                      budget: getSelect('available_budget'),             // valeur du champ "De quelle enveloppe budgétaire disposes-tu pour tes travaux ?"
                      ville: getField('zip'),                           // valeur du champ "Dans quelle ville se situe ton projet de rénovation ?"
                      prenom: getField('firstname'),                    // valeur du champ "Quel est ton prénom ?"
                      nom: getField('lastname'),                        // valeur du champ "Quel est ton nom de famille ?"
                      email: getField('email'),                         // valeur du champ "Quelle est ton adresse e-mail ?"
                      telephone: getField('phone'),
                    },
                  }),
                  mode: 'cors',
                });
              });
            }
          }
        })
      }

    });
  }, []);

  return <React.Fragment>
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.slice_type}
      className={`form bg-white bg-grain text-dark-grey ${index !== 0 ? 'border-t-2 border-dark-grey' : ''}`}>
      <div className="h1-like  max-w-[1400px] pt-24 px-4 pb-10 md:pt-28 md:px-10 m-auto">
        <div className="mb-3">
          <PrismicRichText field={slice.primary.title} />
        </div>
        <div>
          <PrismicRichText field={slice.primary.text} />
        </div>
      </div>
    </section>

    <section className="bg-beige bg-grain relative text-dark-grey border-t-2 border-dark-grey">
      <div className="md:hidden absolute right-[17px] -top-[45px] flex">
        <GoogleReview note={slice.primary.note} picto={slice.primary.picto} />
      </div>
      <div className="md:flex max-w-[1400px] m-auto py-16 px-4 md:pb-24 md:px-10 ">
        <div className="md:w-1/2 flex-1 md:mb-20">
          <div id="laformaflo"></div>
          <div className="mentions-newsletter">
            <PrismicRichText field={slice.primary.texte_rgpd} />
          </div>
        </div>
        <div className="hidden md:flex flex-1 md:w-1/2 flex-col items-end ml-16 min-h-screen">
          <div className="bg-cover bg-no-repeat mb-16 border-2 border-dark-grey rounded-l-[90px] flex-1 w-full relative"
            style={{ backgroundImage: `url(${slice.primary.picture.url})` }} aria-label={slice.primary.picture.alt}>
            <div className="hidden md:flex absolute -left-[20px] -top-[20px]">
              <GoogleReview note={slice.primary.note} picto={slice.primary.picto} />
            </div>
          </div>
          <div className="w-fit pr-5 border-r border-dark-grey text-end">
            <PrismicRichText field={slice.primary.secondary_text} />
          </div>
        </div>
      </div>
    </section>
  </React.Fragment>
};

export default Form;
